import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import ReactPaginate from "react-paginate";

import { useWeb3React } from "@web3-react/core";
import SafeMarsNFTContractJSON from "../contracts/SafeMarsNFT.json";

function MyNfts({ web3 }) {
  // const prov = new AnkrscanProvider();
  const { tokenAddr, tokenId } = useParams();
  const fallbackImg =
    "data:image/png;base64,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";
  const { account, library, active } = useWeb3React();

  const [items, setItems] = useState([]);
  const [displayItems, setDisplayItems] = useState([]);
  const [itemOffset, setItemOffset] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(async () => {
    setItems([]);
    await getMyNfts();
  }, [active]);

  useEffect(async () => {
    setDisplayItems([]);
  }, [!active]);

  const getAllNfts = async (chains, address) => {
    const body = {
      jsonrpc: "2.0",
      method: "ankr_getNFTsByOwner",
      params: {
        blockchain: chains,
        walletAddress: address,
        pageSize: 2,
        pageToken: "",
      },
      id: 1,
    };

    const res = await fetch("https://rpc.ankr.com/multichain", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });

    const data = await res.json();

    return data;
  };

  const getMyNfts = async () => {
    //???Connect wallet for this
    try {
      const safeMarsNFTContract = new library.eth.Contract(
        SafeMarsNFTContractJSON.abi,
        process.env.REACT_APP_SAFEMARS_NFT
      );

      //??????? start
      const res = await getAllNfts(["bsc"], account);

      if (res && res.result.assets.length > 0) {
        const assets = res.result.assets;
        for (let asset of assets) {
          if (!asset) continue;
          if (asset.tokenId === 0) continue;
          if (!asset.tokenUrl) continue;
          const id = asset.tokenId;
          const tokenURI = asset.tokenUrl;
          const metaData = await fetch(tokenURI);
          const data = await metaData.json();
          data.contractAddress = asset.contractAddress;
          data.tokenID = +id;
          if (data.animation_type) {
            data.media_type = data.animation_type.split("/")[0];
          }

          if (data.attributes.content_type) {
            const contentType = data.attributes.content_type.split("/")[0];

            if (contentType === "video" || contentType === "audio") {
              data.media_type = contentType;
              data.animation_type = data.attributes.content_type;
              data.animation_url = data.image;
              delete data.image;
            }
          }

          setItems((oldArray) => {
            const newArray = [...oldArray];
            newArray.push(data);
            return newArray;
          });
          setDisplayItems((oldArray) => {
            const newArray = [...oldArray];
            newArray.push(data);
            return newArray;
          });
          // console.log(data);
        }
      }
      //??????? end

      // const tokenIDs = await safeMarsNFTContract.methods
      //   .getMyNftTokens()
      //   .call({ from: account });

      // if (tokenIDs.length > 0) {
      //   for (const [id, tokenURI] of tokenIDs) {
      //     const metaData = await fetch(tokenURI);
      //     const data = await metaData.json();
      //     data.contractAddress = process.env.REACT_APP_SAFEMARS_NFT;
      //     data.tokenID = +id;
      //     if (data.animation_type) {
      //       data.media_type = data.animation_type.split("/")[0];
      //     }
      //     setItems((oldArray) => {
      //       const newArray = [...oldArray];
      //       newArray.push(data);
      //       return newArray;
      //     });
      //     setDisplayItems((oldArray) => {
      //       const newArray = [...oldArray];
      //       newArray.push(data);
      //       return newArray;
      //     });
      //   }
      // }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  const search = async (value) => {
    const data = items.filter((item) =>
      item.name.toLowerCase().includes(value.toLowerCase())
    );

    setDisplayItems(data);
  };

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % displayItems.length;
    setItemOffset(newOffset);
  };

  const itemsPerPage = 12;
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = displayItems.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(displayItems.length / itemsPerPage);

  return (
    <div>
      <section class="py-5 item-bg position-relative">
        <div id="particles-js"></div>
        <div class="container py-5 mt-5 z-index-20">
          <h1 class="text-center white-color">MY NFTS</h1>

          <nav aria-label="breadcrumb">
            <ol class="breadcrumb justify-content-center">
              <li class="breadcrumb-item">
                <a
                  class="text-decoration-none d-flex align-items-center"
                  href="#"
                >
                  {" "}
                  <i class="las la-home la-sm me-1"></i>Home
                </a>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Explore
              </li>
            </ol>
          </nav>
        </div>
      </section>

      <section class="py-5">
        <div class="container" id="nft_container">
          {/* <div class="controls d-flex flex-column flex-md-row mb-4 p-1 bg-dark bd-3 rounded button-group filter-button-group">
            <button
              class="mixitup-control flex-fill m-1 mixitup-control-active"
              type="button"
              data-filter="*"
            >
              All
            </button>
            <button
              class="mixitup-control flex-fill m-1"
              type="button"
              data-filter=".art"
            >
              Haloween
            </button>
            <button
              class="mixitup-control flex-fill m-1"
              type="button"
              data-filter=".music"
            >
              Space
            </button>
            <button
              class="mixitup-control flex-fill m-1"
              type="button"
              data-filter=".collectibles"
            >
              1st Landing
            </button>
            <button
              class="mixitup-control flex-fill m-1"
              type="button"
              data-filter=".utility"
            >
              Mars Dog
            </button>
            <button
              class="mixitup-control flex-fill m-1"
              type="button"
              data-filter=".community"
            >
              Community
            </button>
          </div> */}

          <header className="mb-4">
            <form action="#">
              <ul
                className="list-inline d-flex align-items-center flex-wrap"
                id="explore-filter"
              >
                <li className="list-inline-item mb-2 ">
                  <div className="input-group rounded bd-3 bg-dark">
                    <input
                      className="form-control border-0 bg-none shadow-0"
                      type="search"
                      name="email"
                      placeholder="Search item here..."
                      onInput={(e) => search(e.target.value)}
                    />
                    <button
                      className="btn btn-primary btn-sm m-1 rounded-sm"
                      type="submit"
                    >
                      <i className="las la-search"></i>
                    </button>
                  </div>
                </li>
              </ul>
            </form>
          </header>

          <div
            class="row mixitUpContainer gy-4 mb-5 grid"
            id="nft_sub_container"
          >
            <div className="d-flex justify-content-center">
              <ClipLoader
                color={"#ffffff"}
                loading={loading}
                size={80}
                aria-label="Loading Spinner"
                data-testid="loader"
              />
            </div>

            {!active && <span>Connect wallet to view page</span>}

            <span
              className={active && currentItems.length === 0 ? "" : "d-none"}
            >
              No Item to display
            </span>
            {currentItems.map(function (data, i) {
              return (
                <div
                  key={i}
                  class="element-item col-xl-3 col-lg-4 col-md-6 mix art"
                >
                  <div class="card rounded shadow-sm card-hover-image">
                    <div class="card-body p-3 position-relative">
                      <div class="position-relative mb-4 shadow">
                        <div class="author z-index-20">
                          {/* <img
                            class="img-fluid rounded-circle"
                            src={data.image}
                            alt="..."
                            width="45"
                          /> */}
                          <span class="icon bg-primary text-white">
                            <i class="las la-check-double"></i>
                          </span>
                        </div>

                        <div class="card-img-holder rounded overflow-hidden">
                          {data.image && (
                            <img
                              class="img-fluid rounded w-100"
                              src={data.image}
                              alt=""
                            />
                          )}

                          {data.media_type && data.media_type === "video" && (
                            <video
                              width="320"
                              height="240"
                              controlsList="nodownload"
                              controls
                            >
                              <source
                                src={data.animation_url}
                                type={data.animation_type}
                              />
                              Your browser does not support the video element.
                            </video>
                          )}

                          {data.media_type && data.media_type === "audio" && (
                            <audio controlsList="nodownload" controls>
                              <source
                                src={data.animation_url}
                                type={data.animation_type}
                              />
                              Your browser does not support the audio element.
                            </audio>
                          )}
                        </div>
                      </div>

                      <p class="fw-bold mb-3 text-white">
                        <span class="text-reset text-white">{data.name}</span>
                      </p>

                      {/* <p class="text-sm text-muted fw-normal mb-2 d-flex align-items-center">
                        <span class="icon bg-primary text-white me-2">
                          <i class="lab la-bitcoin fa-fw"></i>
                        </span>
                        <span>Price: </span>
                        <span class="text-primary ms-2"></span>
                        <span class="ms-2">1/20</span>
                      </p>

                      <p class="text-sm text-muted fw-normal d-flex align-items-center">
                        <span class="icon bg-primary text-white me-2">
                          <i class="las la-wallet fa-fw"></i>
                        </span>
                        <span>Highest bid: </span>
                        <span class="text-primary ms-2">0.081 ETH</span>
                      </p>

                      <div class="my-3 pt-1 bg-body rounded-pill"></div>

                      <ul class="list-unstyled d-flex align-items-center justify-content-between fw-normal text-sm text-muted mb-0">
                        <li class="d-flex align-items-center">
                          <i class="la-sm text-primary las la-clock me-2 text-primary"></i>
                          12Hrs ago
                        </li>
                        <li class="d-flex align-items-center">
                          <i class="la-sm text-primary las la-heart me-2 text-primary"></i>
                          42 Likes
                        </li>
                      </ul> */}

                      <Link
                        to={{
                          pathname: "/create",
                          nftData: data, // your data array of objects
                        }}
                      >
                        <button class="btn btn-primary btn-sm w-100 mt-4">
                          List NFT
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <ReactPaginate
            breakLabel="..."
            nextLabel="next"
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel="previous"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakClassName="page-item"
            breakLinkClassName="page-link"
            containerClassName="pagination mb-0 justify-content-center"
            activeClassName="active"
            renderOnZeroPageCount={null}
          />
        </div>
      </section>
    </div>
  );
}

export default MyNfts;
